export default function Unauthorized() {
    return "please log in to the organization";
}
